import AbstractComponent from './AbstractComponent';
import { OPENED, ENTER, LEAVE, OUT, STICKY } from 'core/Classes';
import ScrollManager from '../managers/ScrollManager';
import ResizeObserver from 'resize-observer-polyfill'

class Header extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleClickPaneToggle = this.handleClickPaneToggle.bind(this);
    this.handleClickPaneClose = this.handleClickPaneClose.bind(this);
    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleClickLink = this.handleClickLink.bind(this);
    this.handleResizePreHeader = this.handleResizePreHeader.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$preheader = document.querySelector('.pre-header');
    ui.$burger = document.querySelector('.header__burger');
    ui.$menu = document.querySelector('.header__menu');
    ui.$menuClose = document.querySelector('.header__menu__top button');
    ui.$menuOverlay = document.querySelector('.header__overlay');
    ui.$panes = document.querySelector('.header__menu__panes');
    ui.$paneRoot = document.querySelector('.header__menu__pane--root');
    ui.$menuLinks = [...document.querySelectorAll('.header__menu a:not([data-pane-id])')];
    ui.$pane = [...document.querySelectorAll('.header__menu__pane')];
    ui.$paneToggles = [...document.querySelectorAll('a[data-pane-id]')];
    ui.$paneClose = [...document.querySelectorAll('.header__menu__pane__close')];
    return ui;
  }

  initializeBeforeEvents() {
    this.stickyAt = 0;
    this.isSticky = false;

    const preHeaderObserver = new ResizeObserver(this.handleResizePreHeader);
    preHeaderObserver.observe(this.ui.$preheader);
  }

  events(listen) {
    super.events(listen);
    const method = listen ? 'addEventListener' : 'removeEventLister';
    const { $menuLinks, $paneToggles, $paneClose, $burger, $menuClose, $menuOverlay } = this.ui;

    $paneToggles.forEach(($pane) => $pane[method]('click', this.handleClickPaneToggle));
    $paneClose.forEach(($pane) => $pane[method]('click', this.handleClickPaneClose));
    $menuLinks.forEach(($link) => $link[method]('click', this.handleClickLink));
    $burger[method]('click', this.handleMenuToggle);
    $menuClose[method]('click', this.handleMenuToggle);
    $menuOverlay[method]('click', this.handleMenuToggle);
  }

  handleResizePreHeader([entry]) {
    this.stickyAt = entry.contentRect.height;
  }

  handleClickLink(event) {
    const { $menu } = this.ui;
    $menu.classList.remove(OPENED);
    [...$menu.querySelectorAll(`.${ENTER}`)].forEach(($item) => $item.classList.remove(ENTER));
    [...$menu.querySelectorAll(`.${LEAVE}`)].forEach(($item) => $item.classList.remove(LEAVE));
  }

  handleMenuToggle(event) {
    event.preventDefault();
    this.ui.$menu.classList.toggle(OPENED);
  }

  handleScroll(sT = ScrollManager.scrollTop) {
    if (ScrollManager.isDisabled) return;

    if (sT > this.stickyAt && this.isSticky === false) {
      this.isSticky = true;
      this.ui.$element.classList.add(STICKY);
    } else if (sT <= this.stickyAt && this.isSticky) {
      this.isSticky = false;
      this.ui.$element.classList.remove(STICKY);
    }
  }

  handleResize() {
    const { $panes, $pane } = this.ui;
    this.height = this.ui.$element.offsetHeight;
    $panes.style.removeProperty('height');
    requestIdleCallback(() => {
      let maxHeight = 0;
      $pane.forEach(($item) => (maxHeight = Math.max(maxHeight, $item.offsetHeight)));
      $panes.style.height = `${maxHeight}px`;
    });
  }

  handleClickPaneToggle(event) {
    const { $paneRoot } = this.ui;
    const { paneId } = event.currentTarget.dataset;
    const $pane = this.ui.$element.querySelector(`.header__menu__pane[data-id="${paneId}"]`);

    if ($pane) {
      event.preventDefault();
      $pane.classList.add(ENTER);
      $paneRoot.classList.add(LEAVE);
    }
  }

  handleClickPaneClose(event) {
    const { $paneRoot } = this.ui;
    const $pane = event.currentTarget.closest(`.${ENTER}`);

    if ($pane) {
      event.preventDefault();
      $pane.classList.remove(ENTER);
      $paneRoot.classList.remove(LEAVE);
    }
  }

  set visible(value) {
    if (value !== this._visible) {
      this._visible = value;
      this.ui.$element.classList[value ? 'remove' : 'add'](OUT);
    }
  }

  get visible() {
    return this._visible;
  }

  set hasBackground(value) {
    if (value !== this._hasBackground) {
      this._hasBackground = value;
      this.ui.$element.classList[value ? 'add' : 'remove']('has-background');
    }
  }

  get hasBackground() {
    return this._hasBackground;
  }
}

export default Header;
